import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, of } from 'rxjs';

import { Auth } from '../services/auth';

export const managerGuard: CanActivateFn = () => {
  const auth = inject(Auth);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return of(router.createUrlTree(['/login']));
  }

  return auth.hasRoleSession('manager').pipe(
    map((isManager) => (isManager ? true : router.createUrlTree(['/dashboard']))),
  );
};
